import { all } from 'redux-saga/effects';
import loginSaga from 'app/containers/Login/saga';
import profileSaga from 'app/containers/Profile/saga';
import searchSaga from 'app/containers/Search/saga';

export default function* rootSaga() {
  yield all([loginSaga(), profileSaga(), searchSaga()]);
}
